module.exports = __webpack_public_path__ + "static/media/vetements.92051c78.jpg";